package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SkeletonW500Rounded: ImageVector
    get() {
        if (_skeletonW500Rounded != null) {
            return _skeletonW500Rounded!!
        }
        _skeletonW500Rounded = Builder(name = "SkeletonW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(480.0f, 883.83f)
                quadToRelative(-45.48f, 0.0f, -79.34f, -9.62f)
                quadToRelative(-33.86f, -9.62f, -75.38f, -35.62f)
                lineToRelative(-109.48f, -70.0f)
                quadToRelative(-28.28f, -18.0f, -42.76f, -46.98f)
                quadToRelative(-14.47f, -28.98f, -14.47f, -60.22f)
                quadToRelative(0.0f, -67.56f, 47.16f, -104.0f)
                quadToRelative(47.16f, -36.43f, 106.27f, -36.43f)
                quadToRelative(31.39f, 0.0f, 59.25f, 10.21f)
                quadToRelative(27.86f, 10.22f, 50.58f, 31.13f)
                quadToRelative(3.8f, 3.81f, 7.99f, 6.09f)
                quadToRelative(4.18f, 2.28f, 8.75f, 4.57f)
                lineToRelative(0.23f, -73.44f)
                quadToRelative(-52.43f, -3.0f, -96.67f, -12.24f)
                reflectiveQuadToRelative(-76.12f, -24.6f)
                quadToRelative(-31.88f, -15.35f, -49.9f, -36.21f)
                reflectiveQuadToRelative(-18.02f, -47.86f)
                quadToRelative(0.0f, -20.0f, 13.76f, -37.62f)
                quadToRelative(13.76f, -17.62f, 38.52f, -32.86f)
                quadToRelative(-5.76f, -9.0f, -9.02f, -19.38f)
                quadToRelative(-3.26f, -10.38f, -3.26f, -22.14f)
                quadToRelative(0.0f, -21.48f, 16.38f, -41.1f)
                reflectiveQuadToRelative(45.38f, -34.86f)
                quadToRelative(-1.76f, -4.76f, -1.76f, -8.52f)
                verticalLineToRelative(-8.52f)
                quadToRelative(0.0f, -21.33f, 19.51f, -39.11f)
                reflectiveQuadToRelative(51.73f, -29.5f)
                quadToRelative(12.23f, -5.67f, 24.17f, -1.73f)
                quadToRelative(11.93f, 3.95f, 17.85f, 15.95f)
                quadToRelative(5.91f, 12.0f, 1.73f, 24.05f)
                quadToRelative(-4.19f, 12.06f, -16.19f, 17.97f)
                quadToRelative(-10.65f, 3.8f, -17.88f, 7.23f)
                quadToRelative(-7.23f, 3.42f, -11.03f, 7.23f)
                quadToRelative(5.24f, 5.0f, 21.3f, 11.02f)
                quadToRelative(16.07f, 6.02f, 49.52f, 8.78f)
                verticalLineToRelative(-83.87f)
                quadToRelative(0.0f, -17.48f, 11.86f, -29.34f)
                reflectiveQuadTo(480.0f, 70.43f)
                quadToRelative(17.48f, 0.0f, 29.34f, 11.86f)
                reflectiveQuadToRelative(11.86f, 29.34f)
                verticalLineToRelative(83.87f)
                quadToRelative(33.45f, -2.76f, 49.52f, -8.78f)
                quadToRelative(16.06f, -6.02f, 21.3f, -11.02f)
                quadToRelative(-3.8f, -3.05f, -10.65f, -6.47f)
                quadToRelative(-6.85f, -3.43f, -17.5f, -7.23f)
                quadToRelative(-12.0f, -5.91f, -16.45f, -18.35f)
                quadToRelative(-4.44f, -12.43f, 1.47f, -24.43f)
                reflectiveQuadTo(567.0f, 103.27f)
                quadToRelative(12.2f, -3.94f, 24.44f, 1.73f)
                quadToRelative(20.84f, 9.2f, 45.66f, 25.72f)
                quadToRelative(24.81f, 16.52f, 24.81f, 42.89f)
                quadToRelative(0.0f, 0.24f, -1.76f, 17.04f)
                quadToRelative(29.0f, 15.24f, 45.38f, 34.48f)
                quadToRelative(16.38f, 19.24f, 16.38f, 41.48f)
                quadToRelative(0.0f, 11.76f, -3.26f, 22.14f)
                reflectiveQuadToRelative(-9.02f, 19.38f)
                quadToRelative(24.76f, 15.24f, 38.52f, 32.86f)
                quadToRelative(13.76f, 17.62f, 13.76f, 37.62f)
                quadToRelative(0.0f, 27.0f, -18.02f, 47.86f)
                reflectiveQuadToRelative(-49.9f, 36.21f)
                quadToRelative(-31.88f, 15.36f, -76.12f, 24.6f)
                quadToRelative(-44.24f, 9.24f, -96.67f, 12.24f)
                verticalLineToRelative(73.44f)
                quadToRelative(4.56f, -2.29f, 8.75f, -4.57f)
                quadToRelative(4.18f, -2.28f, 7.98f, -6.09f)
                quadToRelative(22.24f, -20.91f, 50.94f, -31.13f)
                quadToRelative(28.7f, -10.21f, 59.13f, -10.21f)
                quadToRelative(58.87f, 0.0f, 106.15f, 36.93f)
                quadToRelative(47.28f, 36.94f, 47.28f, 104.5f)
                quadToRelative(0.0f, 31.72f, -14.47f, 60.46f)
                quadToRelative(-14.48f, 28.74f, -43.24f, 46.74f)
                lineToRelative(-109.0f, 69.0f)
                quadToRelative(-41.76f, 26.0f, -75.38f, 35.62f)
                quadToRelative(-33.62f, 9.62f, -79.34f, 9.62f)
                close()
                moveTo(536.14f, 793.0f)
                quadToRelative(24.14f, -7.0f, 53.66f, -25.52f)
                lineToRelative(109.0f, -69.0f)
                quadToRelative(9.29f, -5.76f, 14.05f, -15.55f)
                quadToRelative(4.76f, -9.78f, 4.76f, -20.54f)
                quadToRelative(0.0f, -27.32f, -21.81f, -42.47f)
                quadToRelative(-21.8f, -15.14f, -47.8f, -15.14f)
                quadToRelative(-14.76f, 0.0f, -28.28f, 4.38f)
                quadToRelative(-13.52f, 4.38f, -24.05f, 13.14f)
                quadToRelative(-24.47f, 21.48f, -53.95f, 32.98f)
                quadToRelative(-29.48f, 11.5f, -61.72f, 11.5f)
                quadToRelative(-32.24f, 0.0f, -61.72f, -11.5f)
                quadToRelative(-29.48f, -11.5f, -53.95f, -32.98f)
                quadToRelative(-10.53f, -8.76f, -24.05f, -13.14f)
                quadToRelative(-13.52f, -4.38f, -28.28f, -4.38f)
                quadToRelative(-26.0f, 0.0f, -47.8f, 14.76f)
                quadToRelative(-21.81f, 14.76f, -21.81f, 41.85f)
                quadToRelative(0.0f, 10.52f, 4.76f, 20.93f)
                quadToRelative(4.76f, 10.4f, 14.05f, 16.16f)
                lineToRelative(109.23f, 69.76f)
                quadToRelative(29.29f, 18.52f, 53.43f, 25.14f)
                quadTo(448.0f, 800.0f, 480.0f, 800.0f)
                reflectiveQuadToRelative(56.14f, -7.0f)
                close()
                moveTo(438.8f, 434.74f)
                verticalLineToRelative(-55.22f)
                quadToRelative(-39.23f, -2.0f, -72.54f, -8.76f)
                quadToRelative(-33.3f, -6.76f, -59.3f, -18.52f)
                quadToRelative(-20.13f, 8.8f, -30.39f, 16.59f)
                quadToRelative(-10.27f, 7.78f, -12.98f, 12.02f)
                quadToRelative(5.11f, 12.43f, 47.08f, 30.78f)
                quadToRelative(41.98f, 18.35f, 128.13f, 23.11f)
                close()
                moveTo(351.0f, 693.39f)
                quadToRelative(9.0f, -9.0f, 9.0f, -21.0f)
                reflectiveQuadToRelative(-9.0f, -21.0f)
                quadToRelative(-9.0f, -9.0f, -21.0f, -9.0f)
                reflectiveQuadToRelative(-21.0f, 9.0f)
                quadToRelative(-9.0f, 9.0f, -9.0f, 21.0f)
                reflectiveQuadToRelative(9.0f, 21.0f)
                quadToRelative(9.0f, 9.0f, 21.0f, 9.0f)
                reflectiveQuadToRelative(21.0f, -9.0f)
                close()
                moveTo(438.8f, 314.5f)
                verticalLineToRelative(-53.98f)
                quadToRelative(-26.76f, -2.0f, -49.56f, -7.26f)
                quadToRelative(-22.81f, -5.26f, -40.57f, -13.02f)
                quadToRelative(-20.84f, 8.04f, -31.6f, 15.83f)
                quadToRelative(-10.77f, 7.78f, -13.72f, 12.26f)
                quadToRelative(2.91f, 13.52f, 37.55f, 27.46f)
                quadToRelative(34.64f, 13.95f, 97.9f, 18.71f)
                close()
                moveTo(521.2f, 434.74f)
                quadToRelative(86.15f, -4.76f, 128.13f, -23.11f)
                quadToRelative(41.97f, -18.35f, 47.08f, -30.78f)
                quadToRelative(-2.71f, -4.24f, -12.59f, -12.02f)
                quadToRelative(-9.89f, -7.79f, -30.02f, -16.59f)
                quadToRelative(-26.0f, 11.76f, -59.3f, 18.52f)
                reflectiveQuadToRelative(-73.3f, 8.76f)
                verticalLineToRelative(55.22f)
                close()
                moveTo(521.2f, 314.74f)
                quadToRelative(63.26f, -4.52f, 97.78f, -18.71f)
                quadToRelative(34.52f, -14.18f, 37.67f, -27.7f)
                quadToRelative(-2.95f, -3.72f, -12.57f, -11.5f)
                quadToRelative(-9.62f, -7.79f, -31.99f, -16.59f)
                quadToRelative(-17.76f, 8.52f, -40.57f, 13.4f)
                quadToRelative(-22.8f, 4.88f, -50.32f, 6.88f)
                verticalLineToRelative(54.22f)
                close()
                moveTo(651.0f, 693.39f)
                quadToRelative(9.0f, -9.0f, 9.0f, -21.0f)
                reflectiveQuadToRelative(-9.0f, -21.0f)
                quadToRelative(-9.0f, -9.0f, -21.0f, -9.0f)
                reflectiveQuadToRelative(-21.0f, 9.0f)
                quadToRelative(-9.0f, 9.0f, -9.0f, 21.0f)
                reflectiveQuadToRelative(9.0f, 21.0f)
                quadToRelative(9.0f, 9.0f, 21.0f, 9.0f)
                reflectiveQuadToRelative(21.0f, -9.0f)
                close()
                moveTo(480.0f, 702.39f)
                close()
            }
        }
        .build()
        return _skeletonW500Rounded!!
    }

private var _skeletonW500Rounded: ImageVector? = null
